const apiUrl = process.env.REACT_APP_API_URL;

export const addCategory = async(name) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/addCategory`;       
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify({
            name
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}




export const getCategories = async() => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/getCategories/1`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}


export const getCategory = async(id) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/getCategory/${id}`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return {  }
    }
}



export const updateCategory = async(id, name, isActive) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/updateCategory`;       
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            id, name, isActive
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return {  }
    }
}
